import { defineStore } from 'pinia'
import api from '@/services/api'

export const useUserStore = defineStore('user', {
  state: () => ({
    profile: null,
    loading: false,
    error: null
  }),

  actions: {
    async fetchProfile() {
      this.loading = true
      this.error = null
      
      try {
        const response = await api.get('/api/v1/user/my/')
        this.profile = response.data
      } catch (error) {
        this.error = error.response?.data?.detail || 'Failed to fetch profile'
        console.error('Failed to fetch profile:', error)
      } finally {
        this.loading = false
      }
    }
  }
}) 